var map = {
	"./screen1.png": 366,
	"./screen2.png": 367,
	"./screen3.png": 368,
	"./screen4.png": 369,
	"./screen5.png": 370,
	"./screen6.png": 371,
	"./screen7.png": 372,
	"./screen8.png": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;